<template>
  <nav class="global-navigation" :class="`global-navigation__${current}`">
    <ul class="global-navigation__list">
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'home' }"
      >
        <router-link class="global-navigation__list__item-link" to="/home">
          <navigation-home-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.home') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'race' }"
      >
        <router-link class="global-navigation__list__item-link" to="/">
          <navigation-race-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.race') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'standings' }"
      >
        <router-link class="global-navigation__list__item-link" to="/standings">
          <navigation-standings-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.standings') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'mission' }"
      >
        <router-link class="global-navigation__list__item-link" to="/mission">
          <navigation-mission-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.mission') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'link' }"
      >
        <router-link class="global-navigation__list__item-link" to="/link">
          <navigation-link-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.links') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'notification' }"
      >
        <navigation-notification-icon-section :hasName="true" :current="current" />
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'mypage' }"
      >
        <router-link class="global-navigation__list__item-link" to="/mypage">
          <NavigationMyPageIconParts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.mypage') }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import NavigationHomeIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationHomeIconParts.vue'
import NavigationRaceIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationRaceIconParts.vue'
import NavigationStandingsIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationStandingsIconParts.vue'
import NavigationLinkIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationLinkIconParts.vue'
import NavigationMyPageIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationMyPageIconParts.vue'
import NavigationNotificationIconSection from '@/components/common/GlobalNavigation/GlobalNavigationPane/NavigationNotificationIconSection.vue'
import NavigationMissionIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationMissionIconParts.vue'

/**
 * グローバルナビゲーション
 */
export default defineComponent({
  name: 'GlobalNavigationSection',
  components: {
    NavigationMissionIconParts,
    NavigationHomeIconParts,
    NavigationRaceIconParts,
    NavigationStandingsIconParts,
    NavigationLinkIconParts,
    NavigationMyPageIconParts,
    NavigationNotificationIconSection,
  },
  props: {
    /**
     * カレント表示指定
     */
    current: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.global-navigation {
  &__list {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: stretch;
    gap: 14px;

    &__item {
      flex: 0;

      &-link {
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 36px;
        height: 48px;
        color: $black;
        border-bottom: 2px solid transparent;
      }

      &-icon {
        fill: $black;
        opacity: 0.3;
      }

      &-name {
        margin-top: 2px;
        font-size: 10px;
        color: $black;
        line-height: 1.4;
        white-space: nowrap;
        opacity: 0.75;
      }

      &--current {
        .global-navigation__list__item-link {
          border-bottom-color: $black;
        }

        .global-navigation__list__item-icon {
          opacity: 1;
        }

        .global-navigation__list__item-name {
          opacity: 1;
        }
      }
    }
  }

  &__race {
    .global-navigation__list__item {
      .global-navigation__list__item-link {
        color: $white;
      }

      &-icon {
        fill: $white;
        opacity: 0.3;
      }

      &-name {
        color: $white;
        opacity: 0.75;
      }

      &--current {
        .global-navigation__list__item-link {
          border-bottom-color: $white;
        }

        .global-navigation__list__item-icon {
          opacity: 1;
        }

        .global-navigation__list__item-name {
          opacity: 1;
        }
      }
    }
  }

  @media screen and (max-width: $responsiveTableLandscapeWidth - 1px) {
    &__list {
      gap: 6px;
    }
  }

  @media screen and (max-width: $responsiveTabletWidth - 1px) {
    &__list {
      gap: min(#{convertPXtoVW(12)}, 12px);
    }
  }
}
</style>
